<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش محصولات پر فروش</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :extraQuery="excelUrl" :url="url" />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12 mb-1">
            <b-form-group class="col-4">
                <multiselect
                    placeholder="انتخاب انبار"
                    v-model="selectedStores"   
                    open-direction="bottom"
                    :options="stores"
                    label="label"
                    track-by="id"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="false"
                    :show-labels="false"
                    :disabled="disabled"
                >
                    <template slot="noOptions">موردی یافت نشد</template>
                    <template slot="noResult">موردی یافت نشد</template>
                </multiselect>

            </b-form-group>
          <DatePickerRange class="col-md-6" v-model="filterDate" />
            <b-form-group class="col-md-6" label="دسته بندی">
                <treeselect
                    :options="realOptions"
                    v-model="category_id"
                    :searchable="true"
                    :show-count="true"
                    noChildrenText="فرزندی وجود ندارد"
                    noOptionsText="موردی وجود ندارد"
                    noResultsText="موردی یافت نشد"
                    :default-expand-level="1"
                    label="title"
                >
                    <label
                    slot="option-label"
                    slot-scope="{
                        node,
                        shouldShowCount,
                        count,
                        labelClassName,
                        countClassName,
                    }"
                    :class="labelClassName"
                    >
                    {{ node.label }}
                    </label>
                </treeselect>
            </b-form-group>
        </div>
        <ProductSearch
          class="row col-md-12"
          ref="productSearch"
          :selectable="true"
          :disabled="disabled"
          @selectProduct="selectProduct"
          :show-label="false"
          @selectVariety="selectVariety"
        />
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
            <template v-slot:cell(product_id)="data">  
                  <a  
                  :href="`/admin/products/edit/${data.item.product_id}`"  
                  class="btn btn-primary"  
                  target="_blank"  
                  rel="noopener noreferrer"  
                >{{ data.item.product_id }}</a>  
            </template>  
          <template v-slot:cell(total_sale)="data">
            {{ data.item.total_sale < 0 ? "-" : ""
            }}{{ data.item.total_sale | price }}
          </template>
          <template v-slot:cell(product_title)="data">
            <a
              target="_blank"
              v-if="data.item.product_title"
              :href="'/admin/products/edit/' + data.item.product_id"
              >{{ data.item.product_title }}</a
            >
            <span v-else>{{ data.item.variety_title }}</span>
          </template>

          <template v-slot:cell(refund_count)="data">
            {{ data.item.refund_count | price }}
          </template>
          <template v-slot:cell(sales_count)="data">
            {{ data.item.sales_count | price }}
          </template>
          <template v-slot:cell(purchase_price)="data">
            {{ data.item.purchase_price | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(sum_refund_amount)="data">
            {{ data.item.sum_refund_amount | price }}
          </template>
          <template v-slot:cell(total)="data">
            {{ data.item.total | price }}
          </template>
          <template v-slot:cell(total_sell)="data">
            {{ data.item.total_sell | price }}
          </template>
          <template v-slot:cell(sum_discount_amount)="data">
            {{ data.item.sum_discount_amount | price }}
          </template>
          <template v-slot:cell(show)="data">
            <button
                style="justify-content: center;align-items: center;border-radius: 5px;position: static;"
                data-toggle="modal"   
                data-target="#excel-modal"
                type="button"
                class="btn btn-primary btn-sm btn-icon not-in-print"
                @click="showVarietiesBalance(data.item.product_id,data.item.product_title)"
              >
                <span class="fe fe-eye text-info"></span>
              </button>
            </template>
          <template #bottom-row="data">
            <b-td colspan="2">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.total_quantity | price }}
            </b-td>
            <b-td>
              {{ totals.purchase_price | price }}
            </b-td>
            <b-td>
              {{ totals.sell_price | price }}
            </b-td>
            <b-td>
              {{ totals.discount_amount | price }}
            </b-td>
            <b-td>
              {{ totals.sales_count | price }}
            </b-td>
            <b-td>
              {{ totals.total | price }}
            </b-td>
            <b-td>
              {{ totals.total_sell | price }}
            </b-td>
            <b-td>
              *
            </b-td>
          </template>
        </b-table>

        <div v-if="categories && !reports" class="alert alert-primary">دیتایی وجود ندارد</div>
        <div v-else-if="categories && disabled" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
     <div class="modal fade" id="excel-modal" v-if="isProduct" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-content-demo">
          <div class="modal-header">
              <p class="modal-title font-weight-bold">فروش تنوع محصول ({{ productTitle }})</p>
              <button aria-label="Close" class="close" data-dismiss="modal"><span
                      aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <div class="row p-4" v-if="varieties">
              <table class="table table-striped table-responsive-sm table-bordered table-hover">
                <thead class="bg-gray">
                    <tr>
                        <th>ردیف</th>
                        <th>تنوع</th>
                        <th>تعداد فروش</th>
                        <th>مجموع فروش</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(variety,index) in varieties" :key="index">
                        <td class="font-weight-bold">{{ index + 1 }}</td>
                        <td>{{ variety.variety_title }}</td>
                        <td>{{ variety.sales_count }}</td>
                        <td>{{ variety.total_sell | price }}</td>
                    </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-center align-items-center" style="width: 100%;">
                <Loading v-if="$root.isEmptyObject(varieties)" />
              </div>
            </div>  
          </div>  
        </div>  
      </div>  
    </div> 
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};
export default {
  name: "ProductsSeller",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ExcelDownload,
    DatePickerRange,
    ProductSearch,
    BButton,
    BTd,
  },
  configProvider,
  data() {
    return {
      url:'admin/reports/only-products-new',
      disabled: true,
      fields: [
        {
          key: "product_id",
          label: "شناسه محصول",
          sortable: true,

        },
        {
          key: "product_title",
          label: "عنوان",
          sortable: true,

        },
        {
          key: "category_name",
          label: "دسته بندی تخصصی",
          sortable: true,

        },
         {
          key: "total_quantity",
          label: "موجودی محصول",
          sortable: true,

        },
          {
          key: "sales_count",
          label: "تعداد فروش",
          sortable: true,

        },
        {
          key: "purchase_price",
          label: "قیمت خرید",
          sortable: true,

        },
        {
          key: "sell_price",
          label: "قیمت فروش",
          sortable: true,

        },
        {
          key: "sum_discount_amount",
          label: "تخفیف",
          sortable: true,

        },
      
        {
          key: "total",
          label: "فروش خالص",
          sortable: true,

        },
        {
          key: "total_sell",
          label: "فروش کل",
          sortable: true,

        },
         {
          key: 'show',
          label: 'تنوع'
        }
      ],
      page: 1,
      reports: null,
      sortBy: null,
      sortDesc: null,
      category_id: null,
      categories: [],
      selectedStores: null,
      stores: [],
      totals : [],
      Product_id: "",
      Variety_id: "",
      showModal: false,  
       productTitle: null,
      Variety_id: "",
      isProduct: true,  
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filter: new Filter(),
      varieties: [],
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadStores();
    this.loadCategoriesData();
  },
  computed: {
    excelUrl() {
      
      const params =  {
            category_id: this.category_id == 0  || !this.category_id ? '' : this.category_id,
            product_id: this.Product_id ? this.Product_id.id : "",
            variety_id: this.Variety_id ? this.Variety_id.id : "",
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
            store_ids: this.selectedStores && this.selectedStores.length > 0 
              ? this.selectedStores.map(store => store.id) 
              : [],
          }
          console.log(params,"params");
          
      // const queryString = Object.entries(params)
      //   .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      //   .join('&');
          return params
      // return `admin/reports/only-products-new?${queryString}`;
    },
    realOptions() {
      let temp = this.$root.addLabel(this.categories);
      temp.unshift({
          label: "ندارد",
          children: [],
          id: 0,
      });

      return temp;
    },
  },
  methods: {
     async showVarietiesBalance(product_id,title) {
      this.isProduct = this.Variety_id ? false : true;
      if(this.isProduct){
        this.productTitle = title;
        const response = await this.$axios(`admin/reports/only-products-new/${product_id}`, {  
          params: {
            category_id: this.category_id == 0  || !this.category_id ? '' : this.category_id,
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
            store_ids: this.selectedStores && this.selectedStores.length > 0 
              ? this.selectedStores.map(store => store.id) 
              : [],
          },
        });  
        this.varieties = response.data.data.reports;  
        console.log(this.varieties,'this.varieties');
        
        this.showModal = true;  
      }
    },  
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
          this.disabled = false;
      } catch (e) {
          this.$root.notify(e);
      } 
    },
    async loadCategoriesData() {
      try {
      const response = await this.$axios.get("admin/categories",{params: {all: 1},});
      this.categories = response.data.data.categories;
      } catch (e) {
          this.$root.notify(e);
      } finally {
          this.disabled = false;
      }
    },
    resetFilter() {
      this.Product_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadData() {
      this.appliedFilter.set(this.filter);
      this.disabledRest = false;
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/only-products-new", {
          params: {
            category_id: this.category_id == 0  || !this.category_id ? '' : this.category_id,
            product_id: this.Product_id ? this.Product_id.id : "",
            variety_id: this.Variety_id ? this.Variety_id.id : "",
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
            store_ids: this.selectedStores && this.selectedStores.length > 0 
              ? this.selectedStores.map(store => store.id) 
              : [],
          },
        });
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
